
import { NavItem } from "@school/a2z-lib";
import { environment } from '../../../environments/environment'


export const MenuItems: NavItem[] = [

  {
    title: 'Teleconsult',
    subtitle: 'Update & Join Video Consult',
    status: '',
    icon: './assets/media/svg/icons/a2z/video-conference.svg',
    urlLink: '/'+environment.apiVersion+'/teleconsult',
  },
  {
    title: 'Account',
    subtitle: 'Profile, User details and more',
    status: '',
    icon: './assets/media/svg/icons/a2z/verified-account.svg',
    urlLink: '/'+environment.apiVersion+'/myprofile',
  },
  {
    title: 'Settings',
    subtitle: 'Password, 2FA & Preference',
    status: '',
    icon: './assets/media/svg/icons/a2z/shield.svg',
    urlLink: '/'+environment.apiVersion+'/settings',
  },
];
